<template>
  <h6 class="mb-0">{{ titlePage }}</h6>
  <p class="mb-0 text-sm">{{ subtitlePage }}</p>
  <hr class="my-3 horizontal dark" />

  <div class="row">
    <div class="col-6">
      <div class="form-group">
        <label for="amount" class="form-label">Amount</label>
        <input id="amount" type="number" class="form-control" v-model="record.amount" />
      </div>
      <div class="form-group">
        <label for="sequence" class="form-label">Product Type</label>
        <select class="dataTable-selector form-select form-select-sm" v-model="record.product_type">
          <option v-for="item in types" :value="item" :key="item" >{{ item }}</option>                        
        </select>
      </div>     
    </div>
    <div class="col-6">
   
      <div class="form-group">
        <label for="sequence" class="form-label">Sas Fee Type</label>
        <select class="dataTable-selector form-select form-select-sm" v-model="record.sas_fee_type" disabled>
          <option v-for="item in sas_fee_types" :value="item" :key="item" >{{ item }}</option>                        
        </select>
      </div>        
      <div class="form-group">
        <label for="sequence" class="form-label">Is Active</label>
        <select class="dataTable-selector form-select form-select-sm" v-model="record.is_active">
          <option v-for="item in active_types" :value="item.value" :key="item.key" >{{ item.key }}</option>                        
        </select>
      </div>        
    </div>
  </div>
  
  
  <div class="mt-4 d-flex justify-content-end">
    <button type="button" name="button" class="m-0 btn btn-light" @click="onCancel()">
        Cancel
    </button>
    <button
        type="button"
        name="button"
        class="m-0 btn bg-gradient-success ms-2"
        @click="onSubmit(record)"
    >
        {{ submitButtonName }}
    </button>
  </div>
</template>
<script>

export default {
  data() {
    return {
      record: {},
      sas_fee_types: ["fixed", "percentage"],
      types: ["indicator", "smart-trade","signal"],
      active_types: [{"key": "Active", "value": true}, {"key": "Inactive", "value": false}]
    };
  },
  props: {
      titlePage: String,
      subtitlePage: String,
      submitButtonName: String,
      onSubmit: { type: Function },
      showLoading: { type: Function },
      hideLoading: { type: Function },
      showFailed: { type: Function },
      onCancel: { type: Function },
      recordProps: { type: Object }
  },
  watch: {
      recordProps: function (newVal, oldVal) { // watch it
        console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        this.record = newVal
      }
  },
  mounted() {
  
  },

  methods: {
    
  }
}
</script>
